var _rect, _path, _circle, _circle2, _circle3, _path2, _g, _rect2, _path3, _path4, _path5, _rect3, _g2, _rect4, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEvmDark = function SvgEvmDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.829,
    height: 23.829,
    x: 0.086,
    y: 0.086,
    fill: "#2A235B",
    stroke: "#130E3A",
    strokeWidth: 0.171,
    rx: 1.914
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#130E3A",
    strokeWidth: 0.171,
    d: "M.086 2C.086.943.943.086 2 .086h20c1.057 0 1.914.857 1.914 1.914v1.514H.086z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.888,
    cy: 1.715,
    r: 0.857,
    fill: "#1E1659"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.115,
    cy: 1.715,
    r: 0.857,
    fill: "#1E1659"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.342,
    cy: 1.715,
    r: 0.857,
    fill: "#1E1659"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E1659",
    d: "M22.697.857a.1.1 0 0 0-.07.031l-.684.684-.684-.684a.1.1 0 1 0-.142.143l.684.684-.684.683a.1.1 0 0 0-.024.111.1.1 0 0 0 .056.055.1.1 0 0 0 .11-.023l.684-.684.684.684a.1.1 0 1 0 .142-.143l-.684-.683.684-.684a.1.1 0 0 0-.072-.174"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#evm-dark_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.257,
    height: 9.257,
    x: 2.227,
    y: 3.942,
    fill: "#2A235B",
    rx: 0.857
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E27625",
    d: "m3.395 4.907 2.994 2.275-.487-1.311zM2.996 10.114l.579 1.736 1.747-.579-.835-1.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E27625",
    d: "m5.18 7.872-.457.892 1.76.048-.17-1.977zM5.324 11.27l.97-.385-.873-.771z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7CCC8",
    d: "m5.324 11.271.928.554.042-.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC6228",
    d: "m5.324 11.27.097-1.156h-.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB8C00",
    d: "m6.412 8.764-.15.936.2 1.029.044-1.356z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#763E1A",
    d: "M3.012 6.064 3.59 8.57l1.607-.539L6.29 7.028 3.397 4.907z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB8C00",
    d: "m6.287 9.583-1.543-.82.45-.731-1.607.539-.59 1.543h2.422l.874.771.164-.156z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC6228",
    d: "m5.421 9.439.868.289.12-.964H4.746z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "m6.29 9.728-.868-.29.603-.289z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E27625",
    d: "m7.823 5.871-.487 1.31 2.995-2.274zM9.24 10.101l-.83 1.17 1.742.579.578-1.736z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E27625",
    d: "M7.4 6.883 7.311 8.83l1.696-.065-.404-.772zM8.309 10.114l-.868.771.97.386z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7CCC8",
    d: "m7.441 10.885.036.94.935-.554z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC6228",
    d: "M9.249 10.114h-.94l.102 1.157z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCAAA4",
    d: "M7.511 11.743v-.28H6.216v.28l-.892-.472.965.771h1.15l.97-.771z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#763E1A",
    d: "M10.332 4.907 7.445 7.028l1.087 1.004 1.613.539.572-2.507z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB8C00",
    d: "m10.144 8.57-1.613-.538.45.732-1.522.882-.142-.882-.094.609.044 1.356v-.002.002l.171.156.868-.771h2.422z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB8C00",
    d: "m5.902 5.87.386 1.158.128 1.8.04.548.002 1.353h.405v-.01.01h.405l.003-1.353.04-.547.134-1.801.386-1.157z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "m7.444 10.885-.181-.193h-.801l-.175.193-.072.579H7.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC6228",
    d: "M8.984 8.764H7.32l.12.964.869-.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "m7.713 9.15.596.289-.868.289z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9.257,
    height: 9.257,
    x: 12.512,
    y: 3.942,
    fill: "#2A235B",
    rx: 0.857
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#evm-dark_svg__b)",
    fillRule: "evenodd",
    d: "m20.114 6.74.172-.424s-.22-.236-.486-.503c-.267-.267-.832-.11-.832-.11l-.644-.731h-2.26l-.644.73s-.565-.156-.832.11c-.266.268-.486.504-.486.504l.172.424-.22.629s.647 2.45.723 2.75c.149.59.25.817.675 1.116.423.299 1.193.817 1.318.896.126.078.283.212.424.212s.298-.134.424-.212c.125-.079.894-.598 1.318-.896s.526-.527.675-1.116c.076-.3.722-2.75.722-2.75z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18.788 6.166s.827 1.002.827 1.216-.104.27-.208.382l-.621.66c-.059.062-.181.157-.11.327.073.17.179.388.06.607-.117.22-.32.367-.449.343-.13-.024-.433-.184-.545-.256s-.466-.366-.466-.478.366-.313.434-.358c.067-.046.376-.223.382-.292.007-.07.004-.09-.087-.262-.09-.171-.255-.4-.228-.552.028-.152.292-.232.481-.303s.553-.206.598-.227.034-.041-.104-.054c-.137-.013-.528-.065-.704-.016s-.477.124-.501.163-.046.041-.021.178.154.793.166.91.037.193-.088.222c-.126.028-.337.078-.41.078s-.284-.05-.409-.078c-.125-.029-.101-.106-.088-.223.012-.116.14-.772.166-.909s.003-.138-.021-.178-.325-.114-.501-.163c-.176-.05-.567.003-.704.016-.138.013-.15.033-.104.054.045.02.409.156.598.227s.453.15.48.303c.028.152-.136.38-.227.552s-.094.192-.088.262.316.246.383.292c.068.045.434.246.434.358s-.354.405-.466.478-.416.232-.545.256-.332-.123-.45-.343-.012-.436.06-.607-.05-.265-.11-.327l-.62-.66c-.104-.111-.209-.168-.209-.382s.828-1.216.828-1.216.699.133.793.133.298-.078.487-.14c.188-.064.313-.064.313-.064s.126 0 .314.063c.189.063.393.141.487.141s.793-.133.793-.133m-.62 3.832c.05.033.019.093-.028.126-.046.033-.674.52-.735.573-.06.054-.15.143-.21.143-.061 0-.15-.089-.212-.143-.06-.053-.688-.54-.735-.573-.046-.033-.078-.093-.026-.126.051-.032.211-.113.432-.227.222-.115.497-.212.54-.212s.319.097.54.212.382.195.433.227",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#evm-dark_svg__c)",
    d: "m18.965 5.703-.643-.731h-2.26l-.644.73s-.565-.156-.832.11c0 0 .753-.067 1.012.354 0 0 .699.134.793.134s.298-.079.487-.141c.188-.063.314-.064.314-.064s.125 0 .314.064c.188.062.392.141.486.141s.793-.134.793-.134c.259-.421 1.012-.353 1.012-.353-.267-.267-.832-.11-.832-.11"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 9.257,
    height: 9.257,
    x: 2.227,
    y: 13.885,
    fill: "#2A235B",
    rx: 0.857
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#evm-dark_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#393D4F",
    d: "M10.283 18.599a3.343 3.343 0 1 0-6.685 0 3.343 3.343 0 0 0 6.685 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.888 20.567a3.6 3.6 0 0 1-1.505-.321l1.808-1.65a1.115 1.115 0 0 1 .014-1.74v-.243H6.9c.279 0 .534.103.73.272.196-.17.452-.272.73-.272h.695v.242a1.115 1.115 0 0 1-.216 1.886c-.135.399-.389.758-.73 1.05v.515h-.854a3.6 3.6 0 0 1-1.367.261M6.9 18.59c.203 0 .39-.07.537-.188l.192.43.192-.433a.86.86 0 1 0-.19-1.122.86.86 0 1 0-.731 1.313m0-.258a.602.602 0 1 0 0-1.203.602.602 0 0 0 0 1.203m0-.257a.344.344 0 1 0 0-.688.344.344 0 0 0 0 .688m2.063-.344a.602.602 0 1 1-1.204 0 .602.602 0 0 1 1.204 0m-.258 0a.344.344 0 1 1-.688 0 .344.344 0 0 1 .688 0",
    clipRule: "evenodd"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 9.257,
    height: 9.257,
    x: 12.172,
    y: 13.885,
    fill: "#2A235B",
    rx: 0.857
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3375BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M16.715 15.941c.868.725 1.863.68 2.148.68-.062 4.123-.536 3.306-2.148 4.462-1.611-1.156-2.082-.339-2.145-4.461.282 0 1.277.044 2.145-.68"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "evm-dark_svg__b",
    x1: 14.055,
    x2: 641.906,
    y1: 378.747,
    y2: 378.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#FF2000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evm-dark_svg__c",
    x1: 25.78,
    x2: 535.712,
    y1: 72.323,
    y2: 72.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF452A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2000"
  })))));
};
export { SvgEvmDark as ReactComponent };